module.exports = __webpack_public_path__ + "static/media/talk_tools_dete.dfc8501b.jpeg";